import { combineReducers } from 'redux'
import auth from './auth'
import appUser from './appUser'
import barcodeProduct from './barcodeProduct'
import hero from './hero'
import banners from './banners'
import brand from './brand'
import user from './user'
import productFeature from './productFeature'
import bin from './bin'
import brandActivity from './brandActivity'
import brandNews from './brandNews'
import brandCover from './brandCover'
import appVersion from './appVersion'

export default combineReducers({
  auth,
  appVersion,
  appUser,
  brand,
  brandActivity,
  brandNews,
  brandCover,
  bin,
  barcodeProduct,
  hero,
  banners,
  user,
  productFeature,
})



// WEBPACK FOOTER //
// ./src/modules/index.js